import { render } from "./GrilleHostingStandtouch.vue?vue&type=template&id=464e2676&scoped=true"
import script from "./GrilleHostingStandtouch.vue?vue&type=script&lang=js"
export * from "./GrilleHostingStandtouch.vue?vue&type=script&lang=js"

import "./GrilleHostingStandtouch.vue?vue&type=style&index=0&id=464e2676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464e2676"]])

export default __exports__